// Generated by Melange

import * as Buhta_landing__Route from "../../Route.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as ReasonReactRouter from "reason-react/ReasonReactRouter.js";
import * as JsxRuntime from "react/jsx-runtime";

function Link(Props) {
  let route = Props.route;
  let className = Props.className;
  let tabIndex = Props.tabIndex;
  let onLinkClicked = Props.onLinkClicked;
  let children = Props.children;
  let disabledOpt = Props.disabled;
  let scrollToTopOpt = Props.scrollToTop;
  const disabled = disabledOpt !== undefined ? disabledOpt : false;
  const scrollToTop = scrollToTopOpt !== undefined ? scrollToTopOpt : true;
  const href = Buhta_landing__Route.toString(route);
  const onClick = function (ev) {
    ev.preventDefault();
    if (disabled) {
      return;
    } else {
      ReasonReactRouter.push(href);
      if (scrollToTop) {
        window.scrollTo(0, 0);
      }
      if (onLinkClicked !== undefined) {
        return Curry._1(onLinkClicked, undefined);
      } else {
        return;
      }
    }
  };
  let tmp = {
    children: children,
    disabled: disabled,
    href: href,
    onClick: onClick
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  if (tabIndex !== undefined) {
    tmp.tabIndex = Caml_option.valFromOption(tabIndex);
  }
  return JsxRuntime.jsx("a", tmp);
}

const make = Link;

export {
  make,
}
/* Buhta_landing__Route Not a pure module */
